import * as THREE from 'three'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import { MeshPortalMaterial, useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import { frontBasicMaterial } from '../utils/materials'
import { Hops } from './Hops'
import { useFrame } from '@react-three/fiber'
import { lerp } from '../utils/utils'

type GLTFResult = GLTF & {
  nodes: {
    logo: THREE.Mesh
    card: THREE.Mesh
    card_content: THREE.Mesh
    hops: THREE.Mesh
    brewing: THREE.Mesh
    photography: THREE.Mesh
  }
}
const meshPortalMaterialProps = {} as any;

export const HopsCard = ({ selected, ...props }: { selected?: any } & JSX.IntrinsicElements['group']) => {
  const { nodes } = useGLTF(require('../assets/3D/card3D.glb')) as GLTFResult
  const portal = useRef<any>(null)
  const [revealed, reveal] = useReducer(() => true, false)
  const [blendValue, setBlendValue] = useState<number>(0)
  const [targetValue, setTargetValue] = useState<number>(0)
  const [initialValue, setInitialValue] = useState<number>(0)
  const [startTime, setStartTime] = useState<number>(0)
  const animationDuration = .3

  useEffect(() => {
    setTargetValue(selected ? 1 : 0)
    setInitialValue(blendValue)
    setStartTime(performance.now())
  }, [selected])

  useFrame(() => {
    const elapsed = (performance.now() - startTime) / 1000 // time in seconds
    const t = Math.min(elapsed / animationDuration, 1) // clamp between 0 and 1

    const lerpedBlendValue = lerp(initialValue, targetValue, t)
    setBlendValue(lerpedBlendValue)

    if (portal.current) {
      portal.current.blend = lerpedBlendValue
    }
  })

  return (
    <group onClick={reveal} {...props} dispose={null}>
      <mesh geometry={nodes.logo.geometry} material={frontBasicMaterial} />
      <mesh geometry={nodes.card.geometry} material={frontBasicMaterial} />
      {!revealed && <mesh geometry={nodes.card_content.geometry} position={[0, 0, .001]} />}
      <mesh name={'2'} geometry={nodes.card_content.geometry}>
        <MeshPortalMaterial ref={portal} transparent {...meshPortalMaterialProps}>
          <ambientLight intensity={1} />
          <Hops position={[0, 0, -4]} />
        </MeshPortalMaterial>
      </mesh>
      {revealed && <mesh geometry={nodes.hops.geometry} material={frontBasicMaterial} />}
    </group>
  )
}

useGLTF.preload(require('../assets/3D/card3D.glb'))
